const SUPABASE_STORAGE_URL = "https://ysinoodoodjbjafytlap.supabase.co/storage/v1/object/public";

/**
 * Transform Supabase storage URL to use image transformation API
 * Serves properly sized images to improve LCP and reduce bandwidth
 * 
 * @param src - Original image URL
 * @param width - Target width (default 800)
 * @param quality - Image quality 1-100 (default 80)
 */
export const getOptimizedImageUrl = (
  src: string | undefined | null, 
  width: number = 800,
  quality: number = 80
): string => {
  if (!src) return '';
  
  // Only transform Supabase storage URLs
  if (!src.includes(SUPABASE_STORAGE_URL)) {
    return src;
  }

  // Extract the path after /object/public/
  const pathMatch = src.match(/\/object\/public\/(.+)/);
  if (!pathMatch) return src;
  
  const objectPath = pathMatch[1];
  
  // Use Supabase Image Transformation API
  // render/image returns optimized WebP with specified dimensions
  return `https://ysinoodoodjbjafytlap.supabase.co/storage/v1/render/image/public/${objectPath}?width=${width}&resize=contain&quality=${quality}`;
};

/**
 * Get thumbnail URL (smaller size for cards/grids)
 */
export const getThumbnailUrl = (src: string | undefined | null): string => {
  return getOptimizedImageUrl(src, 400, 75);
};

/**
 * Get medium sized image URL (for listing cards)
 */
export const getMediumImageUrl = (src: string | undefined | null): string => {
  return getOptimizedImageUrl(src, 600, 80);
};

/**
 * Get large image URL (for detail pages)
 */
export const getLargeImageUrl = (src: string | undefined | null): string => {
  return getOptimizedImageUrl(src, 1200, 85);
};
